import JourneyStage from "../enums/JourneyStage";
import BiDirectionType from "../types/BiDirectionType";
import Utility from "./Utility";

export default class Journey {
	public static stages: string[] = Utility.getEnumValues(JourneyStage);

	public static isAtStep(val: JourneyStage): number {
		switch (val) {
			case JourneyStage.AppointmentTypeSelection:
				return 0;
			case JourneyStage.PatientAttributesQuestionaire:
				return 1;
			case JourneyStage.AppointmentTimeSelection:
				return 2;
			case JourneyStage.PersonalDetailsInput:
				return 3;
			case JourneyStage.HealthCoverDetailsInput:
				return 4;
			case JourneyStage.VerifyPasscodeInput:
				return 6;
			case JourneyStage.TermsAndConditions:
				return 7;
			case JourneyStage.AppointmentPrepayment:
				return 8;
			case JourneyStage.BookingConfirmed:
				return 9;
			default:
				return 0;
		}
	}

	public static goFrom(
		val: JourneyStage,
		direction: BiDirectionType
	): JourneyStage {
		switch (val) {
			case JourneyStage.AppointmentTypeSelection:
				return JourneyStage.PatientAttributesQuestionaire;
			case JourneyStage.PatientAttributesQuestionaire:
				if (direction === "backward")
					return JourneyStage.AppointmentTypeSelection;
				return JourneyStage.AppointmentTimeSelection;
			case JourneyStage.AppointmentTimeSelection:
				if (direction === "backward")
					return JourneyStage.AppointmentTypeSelection;
				return JourneyStage.PersonalDetailsInput;
			case JourneyStage.PersonalDetailsInput:
				if (direction === "backward")
					return JourneyStage.AppointmentTimeSelection;
				return JourneyStage.HealthCoverDetailsInput;
			case JourneyStage.HealthCoverDetailsInput:
				if (direction === "backward")
					return JourneyStage.PersonalDetailsInput;
				return JourneyStage.VerifyPasscodeInput;
			case JourneyStage.VerifyPasscodeInput:
				if (direction === "backward")
					return JourneyStage.AppointmentTypeSelection;
				return JourneyStage.TermsAndConditions;
			case JourneyStage.TermsAndConditions:
				if (direction === "backward")
					return JourneyStage.AppointmentTypeSelection;
				return JourneyStage.AppointmentPrepayment;
			case JourneyStage.AppointmentPrepayment:
				if (direction === "backward")
					return JourneyStage.TermsAndConditions;
				return JourneyStage.BookingConfirmed;
			default:
				return JourneyStage.AppointmentTypeSelection;
		}
	}

	public static disableNextButton(val: JourneyStage): boolean {
		switch (val) {
			case JourneyStage.AppointmentTypeSelection:
				return true;
			case JourneyStage.PatientAttributesQuestionaire:
				return true;
			case JourneyStage.AppointmentTimeSelection:
				return true;
			case JourneyStage.VerifyPasscodeInput:
				return true;
			case JourneyStage.BookingConfirmed:
				return true;
			case JourneyStage.TermsAndConditions:
				return true;
			case JourneyStage.AppointmentPrepayment:
				return true;
			case JourneyStage.PersonalDetailsInput:
				return true;
			case JourneyStage.HealthCoverDetailsInput:
				return true;
			default:
				return false;
		}
	}

	public static disableBackButton(val: JourneyStage): boolean {
		switch (val) {
			case JourneyStage.AppointmentTypeSelection:
				return true;
			case JourneyStage.BookingConfirmed:
				return true;
			case JourneyStage.TermsAndConditions:
				return true;
			// case JourneyStage.VerifyPasscodeInput:
			// 	return true;
			default:
				return false;
		}
	}
}
